import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    text;
    imgUrl;
    disabled;
    ruleForm = {
        textValue: this.$props.text,
        imgUrlValue: this.$props.imgUrl || '',
    };
    radioValue = 'text';
    ishoverImage = false;
    get rules() {
        if (this.radioValue === 'text') {
            return {
                textValue: [{ required: true, message: this.$t('textRule'), trigger: 'blur' }],
            };
        }
        else {
            return {
                imgUrlValue: [{ required: true, message: this.$t('imgRule'), trigger: 'change' }],
            };
        }
    }
    chooseChange() {
        this.$refs.ruleForm?.clearValidate();
        if (this.radioValue === 'text') {
            this.$emit('update:text', this.ruleForm.textValue);
            this.$emit('update:imgUrl', '');
        }
        else {
            this.$emit('update:text', '');
            this.$emit('update:imgUrl', this.ruleForm.imgUrlValue);
        }
    }
    mounted() {
        this.radioValue = this.initRadioValue();
    }
    handleHoverIn() {
        this.ishoverImage = true;
    }
    handleHoverOut() {
        this.ishoverImage = false;
    }
    handleClick(e) {
        e.preventDefault();
        e.stopPropagation();
        this.ruleForm.imgUrlValue = '';
    }
    initRadioValue() {
        const { textValue, imgUrlValue } = this.ruleForm;
        if (textValue || (!textValue && !imgUrlValue))
            return 'text';
        return 'image';
    }
    handleAvatarSuccess(file) {
        let _this = this;
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
            // 图片base64化
            let newUrl = this.result; // 图片路径
            _this.ruleForm.imgUrlValue = newUrl;
        };
        return false;
    }
    isValidate() {
        let isValidate = null;
        this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                isValidate = true;
            }
            else {
                isValidate = false;
            }
        });
        return isValidate;
    }
};
__decorate([
    Prop({ default: '', type: String })
], default_1.prototype, "text", void 0);
__decorate([
    Prop({ default: '', type: String })
], default_1.prototype, "imgUrl", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
__decorate([
    Watch('ruleForm', { deep: true }),
    Watch('radioValue')
], default_1.prototype, "chooseChange", null);
default_1 = __decorate([
    Component({
        name: 'ComparisonCategories',
        i18n: {
            messages: {
                en: {
                    categories: 'Comparison Categories',
                    textRule: 'Please enter text',
                    imgRule: 'Please upload image',
                },
                zh: {
                    categories: '比对类型',
                    textRule: '请输入文字内容',
                    imgRule: '请上传图片',
                },
            },
        },
    })
], default_1);
export default default_1;
